var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilterNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter New"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07031 3.8511C2.07031 2.86911 2.86637 2.07304 3.84837 2.07304H12.146C13.128 2.07304 13.924 2.86911 13.924 3.8511V4.54547C13.924 5.01703 13.7367 5.46929 13.4032 5.80275C13.4032 5.80275 13.4032 5.80275 13.4032 5.80275L9.94882 9.25716C9.83765 9.36833 9.77522 9.51908 9.77522 9.67625V11.065C9.77522 11.5366 9.58789 11.9888 9.25443 12.3223L7.94934 13.6274C7.31088 14.2658 6.21911 13.8137 6.21911 12.9107V9.67625C6.21911 9.51909 6.15667 9.36833 6.0455 9.25715L2.59109 5.80275C2.25764 5.4693 2.07031 5.01705 2.07031 4.54547V3.8511ZM3.84837 3.25841C3.52104 3.25841 3.25568 3.52377 3.25568 3.8511V4.54547C3.25568 4.70267 3.31812 4.85341 3.42928 4.96457L6.8837 8.41898C7.21713 8.75243 7.40448 9.20469 7.40448 9.67625V12.4959L8.41625 11.4841C8.52742 11.3729 8.58985 11.2222 8.58985 11.065V9.67625C8.58985 9.20469 8.77717 8.75244 9.11064 8.41898L12.565 4.96457C12.6762 4.85342 12.7386 4.70267 12.7386 4.54547V3.8511C12.7386 3.52376 12.4733 3.25841 12.146 3.25841H3.84837Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterNew);
export default __webpack_public_path__ + "static/media/ic-filter-new.a8141ae21770b1893f6290d673536fce.svg";
export { ForwardRef as ReactComponent };